import { c as _c } from "react/compiler-runtime";
import type { OnboardingStatus, UserTimelineEventOnboardingInherited } from '@onefootprint/request-types/dashboard';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components';
type OnboardingInheritedEventProps = {
  data: UserTimelineEventOnboardingInherited['data'];
};
const OnboardingInheritedEvent = t0 => {
  const $ = _c(28);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.onboardingInheritedEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    status,
    obConfiguration
  } = data;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp4);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp5);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp6);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      fail: t2,
      pass: t3,
      none: t4,
      pending: t5,
      incomplete: t6,
      error: t7
    };
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const statusToText = t8;
  const t9 = statusToText[status];
  let t10;
  if ($[20] !== t9) {
    t10 = {
      outcome: t9
    };
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== data.onboardingId || $[23] !== obConfiguration) {
    t11 = {
      playbook: <OnboardingTraceLink onboardingId={data.onboardingId} playbook={obConfiguration} />
    };
    $[22] = data.onboardingId;
    $[23] = obConfiguration;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <div className="flex items-center gap-1 flex-wrap"><div className="flex items-center" data-testid="onboarding-decision-event-header"><p className="text-label-2 md:flex md:gap-1 md:whitespace-nowrap"><Trans ns="entity-details" i18nKey={_temp7} values={t10} components={t11} /></p></div></div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default OnboardingInheritedEvent;
function _temp($) {
  return $.onboardingStatus.fail;
}
function _temp2($_0) {
  return $_0.onboardingStatus.pass;
}
function _temp3($_1) {
  return $_1.onboardingStatus.none;
}
function _temp4($_2) {
  return $_2.onboardingStatus.pending;
}
function _temp5($_3) {
  return $_3.onboardingStatus.incomplete;
}
function _temp6($_4) {
  return $_4.onboardingStatus.error;
}
function _temp7($_5) {
  return $_5.auditTrail.timeline.onboardingInheritedEvent.header;
}